var styles = {
  "DraggableRegion": "Online-Store-UI-DraggableRegion_1g75k",
  "hasBackgroundSheet": "Online-Store-UI-DraggableRegion--hasBackgroundSheet_1gqo2",
  "showBackgroundSheet": "Online-Store-UI-DraggableRegion--showBackgroundSheet_zpg0e",
  "fullCollapse": "Online-Store-UI-DraggableRegion--fullCollapse_1ew4u",
  "dragging": "Online-Store-UI-DraggableRegion--dragging_1rf7g",
  "expanded": "Online-Store-UI-DraggableRegion--expanded_1b48a",
  "DragHandle": "Online-Store-UI-DraggableRegion__DragHandle_biv3a",
  "reducedHeightDragHandle": "Online-Store-UI-DraggableRegion--reducedHeightDragHandle_rn5n8",
  "Content": "Online-Store-UI-DraggableRegion__Content_95cj8",
  "scrollable": "Online-Store-UI-DraggableRegion--scrollable_19hpe",
  "ContentInterior": "Online-Store-UI-DraggableRegion__ContentInterior_xq4ms",
  "isModal": "Online-Store-UI-DraggableRegion--isModal_19kp5",
  "exiting": "Online-Store-UI-DraggableRegion--exiting_1yt6k"
};

export { styles as default };
